import { render, staticRenderFns } from "./commissionSetting2.vue?vue&type=template&id=25f10349&scoped=true"
import script from "./commissionSetting2.vue?vue&type=script&lang=js"
export * from "./commissionSetting2.vue?vue&type=script&lang=js"
import style0 from "./commissionSetting2.vue?vue&type=style&index=0&id=25f10349&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.29_babel-core@7.0.0-bridge.0_@babel+core@7.29._a7b6b2d0a8f0803019d019baabfbdad7/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25f10349",
  null
  
)

export default component.exports